import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12 4.5H19.5C20.6046 4.5 21.5 5.39543 21.5 6.5V17.5C21.5 18.6046 20.6046 19.5 19.5 19.5H12M12 4.5H4.5C3.39543 4.5 2.5 5.39543 2.5 6.5V17.5C2.5 18.6046 3.39543 19.5 4.5 19.5H12M12 4.5V19.5M5.5 8.5H9.5M5.5 12H9.5M5.5 15.5H9.5M14.5 8.5H18.5M14.5 12H18.5M14.5 15.5H18.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
